import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';

import { useImportsApi } from '../imports-api';

interface UseImportsListOptions {
  refetchInterval?: number | false;
}

export function useImportsList(projectId: string, options: UseImportsListOptions = {}) {
  const { getAll } = useImportsApi();
  const { ALL_IMPORTS } = QUERY_KEYS;
  const isEnabled = !!projectId;

  const { data, isError, refetch, isFetched } = useQuery({
    queryKey: [ALL_IMPORTS, projectId],
    queryFn: () => resolve(getAll(projectId)),
    enabled: isEnabled,
    refetchInterval: options.refetchInterval ?? false
  });

  return {
    data,
    isError,
    refetch,
    isEnabled,
    isFetched
  };
}
